<template>
  <div class="series-container">
    <div class="box" v-if="box" :style="{ 'background-color': series.color }">
      <p class="box--number" v-if="number">{{ number }}</p>
      <p v-else>&nbsp;</p>
      <p class="box--series">{{ street }}</p>
      <p class="box--text">Series</p>
    </div>
    <div class="rectangle" v-else>
      <div class="rectangle--number" :style="{ background: series.color }" v-if="numberIsDigit">
         <p> {{ number }} </p>
      </div>
      <div v-else class="rectangle--number">&nbsp;</div>
      <p class="rectangle--series">{{ street }} Series</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["series", "box"],
  data() {
    return {
      number: "",
      street: ""
    };
  },
  mounted () {
    this.setBadge();
  },
  computed: {
    numberIsDigit() {
      return this.number != ""
    }
  },
  methods: {
    setBadge () {
      if (!parseInt(this.series.name.charAt(0))) {
        this.number = "";
        this.street = "Broadway";
      } else {
        this.number = this.series.name.match(/\d+/)[0];
        this.street = this.series.name.match(
                /\b([A-Z][a-z']*)(\s[A-Z][a-z']*)*\b/
        )[0];
      }
    }
  },
  watch: {
    series(newVal) {
      this.setBadge();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/SeriesBadge.vue